import { ReactNode } from 'react';
import { Stack, SxProps, Typography } from '@mui/material';

interface DetailsProps {
  label: string;
  description?: string;
  children?: ReactNode;
  direction?: 'row' | 'column';
  sx?: SxProps;
}

const Details = ({
  label,
  description,
  children,
  direction = 'row',
  sx,
}: DetailsProps) => {
  return (
    <Stack
      direction={direction}
      className="details"
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        columnGap: 10,
        rowGap: 1,
        ...sx,
      }}
    >
      <Typography className="details-label" variant="h3" sx={sx}>
        {label}
      </Typography>
      <Typography className="details-description" variant="h5" sx={sx}>
        {description}
      </Typography>
      <>{children}</>
    </Stack>
  );
};

export default Details;
